import { api } from '../api';

const getInitialToken = (body) =>
  api.fetchJSON('token', { method: 'POST', body }).then(({ token }) => Promise.resolve(token));

export const tokenApi = { getInitialToken };
